import { Cell, Tooltip } from 'bold-ui'
import { TextField } from 'components/form'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel } from '../../../model-prescricao'
import { RENOVACAO_TOOLTIP_TEXT } from '../../utils/constants-prescricao'

export interface MedicamentoNaoCadastradoSectionProps {
  path: MetaRoot<MedicamentoFormModel>
  disabled: boolean
}

export default function MedicamentoNaoCadastradoSection({
  path,
  disabled,
}: Readonly<MedicamentoNaoCadastradoSectionProps>) {
  const tooltipText: string | undefined = disabled ? RENOVACAO_TOOLTIP_TEXT : undefined

  return (
    <>
      <Cell size={7} data-cy='PrincipioAtivo'>
        <Tooltip text={tooltipText}>
          <TextField
            name={path.principioAtivoText}
            label='Princípio ativo'
            maxLength={200}
            required
            data-cy='PrincipioAtivoTextField'
            disabled={disabled}
          />
        </Tooltip>
      </Cell>
      <Cell size={5}>
        <Tooltip text={tooltipText}>
          <TextField
            name={path.concentracaoText}
            label='Concentração'
            maxLength={100}
            data-cy='ConcentracaoTextField'
            disabled={disabled}
          />
        </Tooltip>
      </Cell>
    </>
  )
}
